// constants
import { FORM_EVENTS } from '@/scripts/constants';

const captchaStatus = {
  scriptAppended: false,
  widgetReady: false,
};

export default class Captcha {
  constructor({ $element, sitekey, $form }) {
    this.grecaptcha = null;
    this.grecaptchaId = null;
    this.sitekey = sitekey;
    this.interval = null;

    this.$form = $form;
    this.$element = $element;
    this.$captcha = $('<div />', { class: 'g-recaptcha' });

    this.API = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
    setTimeout(() => {
      this.init(); // in preloader we have some troubles because of that
    }, 1000);
  }

  execute() {
    this.grecaptcha.execute(this.grecaptchaId);
  }

  reset() {
    this.grecaptcha.reset(this.grecaptchaId);
  }

  callback(recaptchaToken) {
    this.$element.find('.g-recaptcha-response').val(recaptchaToken);
    this.$form.trigger(FORM_EVENTS.validation_success);
  }

  render() {
    this.grecaptchaId = this.grecaptcha.render(this.$captcha[0], {
      sitekey: this.sitekey,
      size: 'invisible',
      // the callback executed when the user solve the recaptcha
      callback: (recaptchaToken) => {
        this.callback(recaptchaToken);
      },
      'expired-callback': () => {
        this.reset();
      },
    });
  }

  watch() {
    this.interval = setInterval(() => {
      if (captchaStatus.widgetReady) {
        clearInterval(this.interval);
        this.grecaptcha = window.grecaptcha;
        this.render();
      }
    }, 1000);
  }

  init() {
    this.$element.append(this.$captcha);

    if (!captchaStatus.scriptAppended) {
      const script = document.createElement('script');
      captchaStatus.scriptAppended = true;
      $(document.body).append(script);
      script.src = this.API;
      window.onloadCallback = () => {
        captchaStatus.widgetReady = true;
      };
      this.watch();
    } else if (!captchaStatus.widgetReady) {
      this.watch();
    } else {
      this.grecaptcha = window.grecaptcha;
      this.render();
    }
  }
}



// WEBPACK FOOTER //
// ./components/Form/components/Captcha/Captcha.js